import React from 'react';
import styles from './SettingsHeader.module.scss';
import Button from 'component/atom/forms/button/Button';
const SettingsHeader = ({ title, rightButtons = [], rightItem }) => {
  return (
    <div className={styles.header}>
      <h1 className={styles.text}>{title}</h1>
      {rightButtons?.length > 0 && (
        <div className={styles.buttonCont}>
          {rightButtons?.map((item, index) => {
            return (
              <Button
                label={item.label}
                type={item.type}
                variant={item.variant}
                onClick={item.func}
                key={index}
                opicBackground={item.opicBackground}
                isLoading={item.isLoading}
                className={item.className}
              />
            );
          })}
        </div>
      )}
      {rightItem && rightItem}
    </div>
  );
};

export default SettingsHeader;
